import { Field, FieldArray, useFormikContext, ErrorMessage } from "formik";
import { get, isEmpty } from "lodash";
import { Button, Modal } from "react-bootstrap";
import React, { useState, useEffect } from "react";
import { useDeepEffect } from "../../../abstracts";
import {
  FieldDropSide,
  SearchableList,
  CsplTable as Table,
  FieldInputDollar,
  FieldInput,
  PayrollCardHeader,
  PayrollCardBody,
} from "../../../components";
import {
  getNullTableItem,
  OPTIONS_DATA_MAPPER,
  toOptionValuesFromMapper,
  usDateFormat,
} from "../../../utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faTrashAlt,
  faTimes,
  faExclamationTriangle,
} from "@fortawesome/pro-light-svg-icons";
import authService from "../../../components/api-authorization/AuthorizeService";
import { camelCase } from "lodash";
import permissions from "../../../mocks/menuPermissions.json";
import { faSort } from "@fortawesome/pro-solid-svg-icons";
// const paydates = [
//   { label: "12/01/2021", value: "12/01/2021" },
//   { label: "13/02/2021", value: "13/02/2021" },
//   { label: "14/03/2021", value: "14/03/2021" },
// ];

// let x = paydates.length === 1 ? paydates[0].value : null;

const headerData = [
  {
    label: "Plan ID",
    className: "column-loan-plan-id",
    icon: faSort,
  },
  {
    label: "Loan ID",
    className: "column-loan-loan-id",
    icon: faSort,
  },
  {
    label: "Loan repayment amount",
    className: "column-loan-amount",
    icon: faSort,
  },
  {
    label: "Action",
    className: "column-loan-action pl-1",
  },
];

const columns = [
  {
    label: "Plan ID",
    className: "column-loan-id ft-12",
    columnName: "rkPlanNumber",
  },
  {
    label: "Loan ID",
    className: "column-loan-id ft-12",
    columnName: "loanNumber",
  },
  {
    label: "Loan repayment amount",
    className: "column-outstanding-loan-amount ft-12",
    columnName: "repaymentAmount",
  },
  {
    label: "Action",
    className: "column-compensation-errormessage ft-12",
    columnName: "errorMessages",
  },
];

const PayrollErrorReport = ({
  fields,
  data,
  paydate,
  errorList,
  pendingSubmission,
  menu,
  subMenu,
  isWarningSlide,
}) => {
  const {
    values,
    setFieldValue,
    handleChange,
    errors,
    setFieldError,
    setTouched,
  } = useFormikContext();
  // const errorReportDetails = get(values, fields.payrollLoans, []);
  const [isModalOpen, setIsModalOpen] = useState(0);
  const [filteredValues, setFilteredValues] = useState([]);
  const [recordToDelete, setRecordToDelete] = useState({});
  const [deleteLoanarray, setDeleteLoanarray] = useState([]);
  const [showClass, setShowClass] = useState(true);
  const payrollLoansRecordType = values[fields.payrollLoansRecordType];

  let temp = data.map((_) => _.payDate);
  let paydates = temp.map((_) => usDateFormat(_));
  let uniquepaydates = [...new Set(paydates)];
  let x = uniquepaydates.length === 1 ? uniquepaydates[0] : null;
  const [roleName, setRoleName] = useState("VOU");
  useEffect(() => {
    getRole();
  }, []);
  const getRole = async () => {
    setRoleName(await authService.getRole());
  };
  useEffect(() => {
    if (data != null && data.length > 0) {
      setFieldValue(fields.payrollLoans, data);
      //setFieldError(`${fields.payrollLoans}[${0}].repaymentAmount`,data[0].repaymentAmount);

      data?.forEach((_, i) => {
        //setTouched(`${fields.payrollLoans}[${0}].repaymentAmount`,true)
        _?.errorMessages?.forEach((x, ind) => {
          setFieldError(
            x.controlName == "loanNumber"
              ? `${fields.payrollLoans}[${i}].${x.controlName}`
              : `${fields.payrollLoans}[${i}].repaymentAmount`,
            x.messageDescCode
          );
        });
      });
    }
  }, [data]);

  useEffect(() => {
    setFilteredValues(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  useDeepEffect(() => {
    setFilteredValues(
      payrollLoansRecordType == 1
        ? data.filter((_) => !isEmpty(_.errorMessages))
        : data
    );
  }, [payrollLoansRecordType]);

  const removeOne = (item) => {
    setIsModalOpen(true);
    setRecordToDelete(item);
  };

  const onDeleteConfirmClick = () => {
    const selectedId = get(recordToDelete, "id");
    // setFilteredValues(
    //   filteredValues.filter((item) => {
    //     return item.loanId !== selectedId;
    //   })
    // );
    let list = filteredValues.filter((item) => item.id !== selectedId);

    setFilteredValues(list);
    deleteLoanarray.push(selectedId);
    setDeleteLoanarray(deleteLoanarray);

    setFieldValue(fields.payrollLoans, list);
    setFieldValue(fields.deletedLoanIds, deleteLoanarray);

    setIsModalOpen(false);
    setRecordToDelete({});
  };

  const handleClose = () => {
    setIsModalOpen(false);
    setRecordToDelete({});
  };

  const fullText = () => {
    setShowClass(!showClass);
  };

  return (
    <div className="payroll-error-report">
      <div className="plan-sub-heading">Loan Details</div>
      <div className="ft-12 mb-25">
        The loan details displyed may not reflect newly uploaded loan activity.
      </div>
      <div className="d-flex">
        <Field
          isRequired
          label="Show"
          size="smd"
          disabled={pendingSubmission || isWarningSlide}
          placeholder="Show"
          name={`fields.payrollLoansRecordType`}
          value={payrollLoansRecordType}
          direction="bottom"
          options={toOptionValuesFromMapper(
            OPTIONS_DATA_MAPPER.RECORD_TYPES_OPTIONS
          )}
          popupContent={
            <SearchableList
              label="Select record type"
              options={toOptionValuesFromMapper(
                OPTIONS_DATA_MAPPER.RECORD_TYPES_OPTIONS
              )}
              onSelect={(value) =>
                setFieldValue(fields.payrollLoansRecordType, value)
              }
              selectedValue={payrollLoansRecordType}
              name={fields.payrollLoansRecordType}
              isNotTypeAhead
              isRadio
            />
          }
          component={FieldDropSide}
        />
        &nbsp;&nbsp;&nbsp;&nbsp;
        <Field
          isRequired
          label="Pay date"
          size="sm"
          placeholder=""
          name={fields.paydateError}
          value={x}
          disabled={
            x
              ? true
              : false || pendingSubmission || isEmpty(data) || isWarningSlide
          }
          direction="bottom"
          component={FieldInput}
        />
      </div>
      <FieldArray name={fields.payrollLoans}>
        {() => {
          return (
            <>
              <div className="payroll-card-container">
                <>
                  <PayrollCardHeader headerData={headerData} />
                  {!isEmpty(filteredValues) ? (
                    <>
                      {filteredValues.map((errorItem, index) => {
                        let errorType = null;
                        if (!isEmpty(errorItem.errorMessages)) {
                          errorType = errorItem.errorMessages.find(
                            (_) => _.errorType == 2
                          )?.errorType;
                        }

                        return (
                          <PayrollCardBody
                            fieldName={`${fields.payrollLoans}[${index}]`}
                            isLoan={true}
                            planId={errorItem?.rkPlanNumber}
                            disabled={pendingSubmission || isWarningSlide}
                            handleChange={handleChange}
                            errorItem={errorItem}
                            menu={menu}
                            values={values}
                            errorType={errorType == 2 ? 2 : 1}
                            errorList={errorList}
                            index={index}
                            subMenu={subMenu}
                            roleName={roleName}
                            removeOne={removeOne}
                          />
                        );
                      })}
                    </>
                  ) : (
                    <div className="d-flex justify-content-center payroll-accept-card">
                      No data available
                    </div>
                  )}
                </>
              </div>
            </>
          );
        }}
      </FieldArray>
      <Modal show={isModalOpen} onHide={handleClose}>
        <Modal.Body style={{ borderTop: "5px solid #f94f50" }}>
          <div className="text-right">
            <FontAwesomeIcon
              icon={faTimes}
              color="#000"
              onClick={handleClose}
            />
          </div>
          <div className="d-flex">
            <div className="pd-15">
              <FontAwesomeIcon
                icon={faExclamationTriangle}
                color="#f94f50"
                size="3x"
              />
            </div>
            <div className="remove-text">
              <h4>Delete Error ?</h4>
              <p>
                Are you sure you want to delete selected Loan details? Deleted
                information cannot be retrieved or restored
              </p>
              <br />
              <Button
                className="remove-btn mr-4"
                onClick={onDeleteConfirmClick}
              >
                Delete
              </Button>
              <Button className="cancel-btn" onClick={handleClose}>
                Cancel
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default PayrollErrorReport;
